<template lang="pug">
  MglMap(
    ref="map"
    :accessToken="accessToken"
    :mapStyle="mapStyle"
    :zoom="12.8"
    :bearing="10"
    :pitch="10"
    :antialias="true"
    :key="componentKey"
    :center="[-73.975311, 40.751652]"
    @load="onload"
  )
</template>

<script>
import { MglMap, MglMarker, MglPopup } from "vue-mapbox";
import * as THREE from "three";
import GLTFLoader from "three-gltf-loader";
import "./mapbox.css";
export default {
  name: "MapBox",
  components: {
    MglMap
  },
  data() {
    return {
      componentKey: 0,
      modelDelay: 1000,
      accessToken:
        "pk.eyJ1IjoiYXJ0ZW1hcnQiLCJhIjoiY2pzNjAzbWhzMGpkdzRhcGtldWppNm5ldyJ9.KFE8pu7gz29F6gEk4Bn84Q",
      mapStyle: "mapbox://styles/artemart/cjs60jew2208s1fs3rvjhcln9"
    };
  },
  methods: {
    popupAdded(e) {
      e.popup.remove();
    },
    forceRerender() {
      this.modelDelay = 200;
      this.componentKey += 1;
    },
    flow() {
      this.map.flyTo({
        zoom: 17.8,
        pitch: 60,
        bearing: 29.5,
        center: [-73.9746226389974, 40.752557422681086], 
      });
    },
    onload(e) {
      var mapboxgl = require("mapbox-gl");
      this.map = e.map;
      this.map.resize();
      this.map.addControl(new mapboxgl.NavigationControl());

      var mapboxgl = require("mapbox-gl");
      this.map = e.map;
      this.map.resize();
      this.map.addControl(new mapboxgl.NavigationControl());
      setTimeout(() => {
        this.flow();
      }, 50);
      //Подключение модельки
      var modelOrigin = [-73.975311, 40.751652];
      var modelAltitude = 0;
      var modelRotate = [Math.PI / 2, 0, 1];
      var modelAsMercatorCoordinate = mapboxgl.MercatorCoordinate.fromLngLat(
        modelOrigin,
        modelAltitude
      );
      var modelTransform = {
        translateX: modelAsMercatorCoordinate.x,
        translateY: modelAsMercatorCoordinate.y,
        translateZ: modelAsMercatorCoordinate.z,
        rotateX: modelRotate[0],
        rotateY: modelRotate[0],
        rotateZ: modelRotate[1],
        scale: modelAsMercatorCoordinate.meterInMercatorCoordinateUnits() * 4
      };
      //var envMap = new THREE.RGBELoader().load("https://tom-data.vercel.app/envmaps/chrysler.hdr");
      
      // const windowMaterial = new THREE.MeshPhongMaterial( { 
      //     color: 0x996633,
      //     envMap: envMap, 
      //     specular: 0x050505,
      //     shininess: 100
      // }) 
      var customLayer = {
        id: "3d-model",
        type: "custom",
        renderingMode: "3d",
        onAdd: function(map, gl) {
          this.camera = new THREE.Camera();
          this.scene = new THREE.Scene();
          var directionalLight = new THREE.DirectionalLight(0xffffff);
          directionalLight.position.set(100, 0, 100).normalize();
          this.scene.add(directionalLight);
          var directionalLight2 = new THREE.DirectionalLight(0xffffff);
          directionalLight2.position.set(100, 0, -100).normalize();
          this.scene.add(directionalLight2);
          var light = new THREE.AmbientLight(0xffffff, 6); // soft white light (мягкий белый свет)
          this.scene.add(light);
          var loader = new GLTFLoader();
          loader.load(
            "https://tom-data.vercel.app/models/chrysler.glb",
            function(gltf) {
              this.scene.add(gltf.scene);
              //gltf.scene.children[0].children[1].material = windowMaterial;
            }.bind(this)
          );
          this.map = map;
          this.renderer = new THREE.WebGLRenderer({
            canvas: map.getCanvas(),
            context: gl,
            antialias: true
          });
          this.renderer.autoClear = false;
        },
        render: function(gl, matrix) {
          var rotationX = new THREE.Matrix4().makeRotationAxis(
            new THREE.Vector3(1, 0, 0),
            modelTransform.rotateX
          );
          var rotationY = new THREE.Matrix4().makeRotationAxis(
            new THREE.Vector3(0, 1, 0),
            modelTransform.rotateY
          );
          var rotationZ = new THREE.Matrix4().makeRotationAxis(
            new THREE.Vector3(0, 1, 0),
            modelTransform.rotateZ
          );
          var m = new THREE.Matrix4().fromArray(matrix);
          var l = new THREE.Matrix4()
            .makeTranslation(
              modelTransform.translateX,
              modelTransform.translateY,
              modelTransform.translateZ
            )
            .scale(
              new THREE.Vector3(
                modelTransform.scale,
                -modelTransform.scale,
                modelTransform.scale
              )
            )
            .multiply(rotationX)
            .multiply(rotationY)
            .multiply(rotationZ);

          this.camera.projectionMatrix = m.multiply(l);
          this.renderer.state.reset();
          this.renderer.render(this.scene, this.camera);
          this.map.triggerRepaint();
        }
      }
      this.map.addLayer(customLayer, "waterway-label");
    }
  },
  beforeDestroy() {
    this.$el.remove();
  }
};
</script>
<style lang="sass" scoped>
@import "src/sass/general/medias"
@import "src/sass/general/variables"
@import "src/sass/general/text"

.popup
  &__inner
    background: $brown
    padding: 50px
    font-family: 'Futura PT Book'
    min-width: 320px
    border: 1px solid $brown2
    margin-bottom: 30px
    color: $gold
    @media (max-width: $b-mobile)
      min-width: 100%
      padding: 30px
  &__head
    letter-spacing: 1px
    display: flex
    margin-top: 5px
    color: $brown3
    text-transform: uppercase
    justify-content: space-between
  &__name
    font-family: 'Baza'
    font-size: 30px
    letter-spacing: 3px
    font-weight: 600
    line-height: 1.3
    text-transform: uppercase
    margin: 20px 0
  &__get
    margin-bottom: 15px
    .get__part
      display: flex
      color: rgba(255,255,255,.8)
      padding: 15px 0
      border-bottom: 1px solid $brown2
      letter-spacing: 1px
      font-size: 13px
      justify-content: space-between
      p
        margin: 0
        font-weight: 300
      span
        font-weight: 600
  &__address
    color: $brown3
    font-size: 14px
    text-align: right
    margin-top: 10px
    letter-spacing: 1px
</style>
